import './layout.scss';
import Vue from 'vue';
import VueRouter from 'vue-router';
import eventBus from '../../common/js/event-bus/event-bus';
import mstb from '../../modules/MSTB/mstb';
import mhek from '../../modules/MHEK/mhek';
import mhhr from '../../modules/MHHR/mhhr';
import layoutBase from '../layout-base';

Vue.use(VueRouter);
Vue.component('mstb', mstb);
Vue.component('mhek', mhek);
Vue.component('mhhr', mhhr);
/* eslint-disable no-new*/
new Vue({
	extends: layoutBase,
	el: '[data-layout-id=AV9HE-app]',
	mounted() {
		eventBus.$on('openOrsi', (orsiFeature) => {
			if (window.ORSI) {
				switch (orsiFeature) {
					case 'chat':
						window.ORSI.chat.openChat();
						break;
					case 'callrequest':
						window.ORSI.callrequest.openCallrequest();
						break;
					case 'writetous':
						window.ORSI.writetous.openWritetous();
						break;
					default:
				}
			}
		});
	}
});
/* eslint-enable*/
